export const TWIN_API = "TWIN_API";
export const EXCALIBUR_STATUS = {
    SUCCESS: "SUCCESS",
    FAILURE: "FAILURE",
    EXCEPTION: "EXCEPTION",
};
export const ERROR_REPORT_DOWNLOAD_FAILURE_FLASH = {
    type: "error",
    message: "Could not download error report"
};
export const E_FILE_DISABLED_REASON = {
    NO_SELECTION: "Select a request first",
    NOT_SUCCESS: "Only requests with status SUCCESS can be e-filed"
};
